import dynamic from 'next/dynamic';
import { Builder } from '@builder.io/sdk';
import { HELP_CENTRE_LIST_NAME } from './HelpCentreList.types';

const HelpCentreList = dynamic(() => import('./HelpCentreList').then((m) => ({ default: m.HelpCentreList })));

const HelpCentreListConfig = {
  name: HELP_CENTRE_LIST_NAME,
  friendlyName: 'Help Centre List',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Help Centre',
    },
  ],
};

Builder.registerComponent(HelpCentreList, HelpCentreListConfig);
